<section role="region" aria-labelledby="h2Credits">
  <!-- Token: Credits/Liabilities -->
  <div class="sectionHeader" [ngClass]="{'hidden': !isMobile}">
    <h2 id="h2Credits">
      {{ 'k004011' | translate }}
    </h2>
  </div>
  <div>
<!-- Versión Desktop CREDITS -->
<div *ngIf="!isMobile" class="flex-container-row card-white margen1">
  <tech-loading-peq
    class="flex-container-row w-100"
    *ngIf="isLoading; else showData"
  >
  </tech-loading-peq>
  <ng-template #showData>
    <dx-data-grid
      class="tech-table-info"
      [columns]="colsTrades"
      [dataSource]="data"
      [showColumnLines]="false"
      [showRowLines]="true"
      [showBorders]="false"
      [columnAutoWidth]="true"
      [wordWrapEnabled]="false"
      [focusedRowEnabled]="false"
      [paging]="false"
      [showColumnHeaders]="false"
      hoverStateEnabled="false"
      (onRowExpanded)="onRowExpanded($event)"
      (onRowClick)="onRowClick($event)"
      (onRowCollapsed)="onRowCollapsed($event)"
      (onCellPrepared)="onCellPrepared($event)"
    >
      <!--onRowCollapsing Cuando se esta haciendo el cierre-->
      <!--onRowExpanding Cuando se esta abriendo-->
      <dxo-selection mode="single"></dxo-selection>
      <!-- Desactiva cualquier tipo de ordenación-->
      <dxo-sorting mode="none"></dxo-sorting>
      <!-- Plantilla para los datos -->
      <dxi-column
        caption="{{ 'k000036' | translate }}"
        dataField="Name"
        dataType="number"
        width="50%"
        cellTemplate="templateName"
      ></dxi-column>
      <!--Es para poner el boton de expandir salga al final del todo-->
      <dxi-column type="detailExpand"></dxi-column>
      <!--Para visualizar detalle dentro de la tabla -->
      <dxo-master-detail
        [enabled]="true"
        template="detail"
        [autoExpandAll]="false"
      ></dxo-master-detail>
      <!-- Plantilla para los datos -->
      <div
        *dxTemplate="let el of 'detail'"
        class="detailswrapper opendetails_animation"
      >
        <!-- @slideDownUp-->
        <div class="details">
          <div class="tech-table-info-01 details">
            <!-- Asset type -->
            <div class="item">
              <span>{{ 'k004013' | translate }}</span
              ><span>
                {{ el.data.AsseType | trDashEmpty }}
              </span>
            </div>
            <!-- Valuation -->
            <div class="item">
              <span>{{ 'k000133' | translate }}</span
              ><span>
                {{ el.data.AvailableBalance | trCurrency : el.data.Currency }}
              </span>
            </div>
            <!-- Interest -->
            <div class="item">
              <span>{{ 'k004014' | translate }}</span
              ><span>
                {{ el.data.InterestRate / 100 | trPercent : '1.2-2' }}
              </span>
            </div>
            <!-- Opening date -->
            <div class="item">
              <span>{{ 'k004015' | translate }}</span>
              <span>
                {{
                  el.data.OpeningDate == '1900-01-01'
                    ? ('' | trDashEmpty)
                    : (el.data.OpeningDate | date : dateFormat)
                }}
              </span>
            </div>
            <!-- Expiration date -->
            <div class="item">
              <span>{{ 'k004016' | translate }}</span>
              <span>
                {{
                  el.data.MaturiryDate == '1900-01-01'
                    ? ('' | trDashEmpty)
                    : (el.data.MaturiryDate | date : dateFormat)
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- Plantilla para la cabecera -->
      <div *dxTemplate="let row of 'templateName'">
        <section class="tech-table-info-01 principal">
          <div class="info-A">
            <div class="logo-name {{ getColorById(row.data.Id) }}">
              {{ row.data.Name | uppercase | slice : 0 : 2 }}
            </div>
          </div>

          <div class="info-B">
            <p>{{ row.data.Name | trDashEmpty }}</p>
            <p>{{ row.data.AsseType | trDashEmpty }}</p>
          </div>

          <div class="info-C">
            <div>
              {{ row.data.AvailableBalance | trCurrency : row.data.Currency }}
            </div>
            <div><!--Empty space--></div>
          </div>
        </section>
      </div>
    </dx-data-grid>
  </ng-template>
</div>

<!-- Versión Móvil CREDITS -->
<div *ngIf="isMobile" class="flex-container-row card-white margen1">
  <tech-loading-peq
    class="flex-container-row w-100"
    *ngIf="isLoading; else showData"
  >
  </tech-loading-peq>
  <ng-template #showData>
    <dx-data-grid
      class="tech-table-info"
      [columns]="colsTrades"
      [dataSource]="data"
      [showBorders]="false"
      [showColumnLines]="false"
      [showRowLines]="true"
      [columnAutoWidth]="false"
      [wordWrapEnabled]="true"
      [paging]="false"
      [showColumnHeaders]="false"
    >
      <!-- Desactiva cualquier tipo de ordenación-->
      <dxo-sorting mode="none"></dxo-sorting>

      <!-- Plantillas para celdas con html-->
      <div *dxTemplate="let row of 'templateMobile'">
        <div
          class="tech-table-info-01 principal"
          (click)="openDetailPosition(row.data)"
        >
          <div class="info-A">
            <div class="logo-name {{ getColorById(row.data.Id) }}">
              {{ row.data.Name | uppercase | slice : 0 : 2 }}
            </div>
          </div>

          <div class="info-B">
            <p>{{ row.data.Name | trDashEmpty }}</p>
            <p>{{ row.data.AsseType | trDashEmpty }}</p>
          </div>

          <div class="info-C">
            <div>
              {{ row.data.AvailableBalance | trCurrency : row.data.Currency }}
            </div>
            <div><!--Empty space--></div>
          </div>
        </div>
      </div>
    </dx-data-grid>
  </ng-template>
</div>
  </div>
</section>
